import React, { useState } from "react"
import PropTypes from "prop-types"
import ParticipantTile from "../participant-tile"
import Grid from "../grid"
import Filters from "../table/filters"
import Actions from "../table/actions"
import { P } from "../typography"
import Tiles from "../tiles"
import Level from "../level"
import LoadingSpinner from "../loading-spinner"
import { AdjustedSearchBox, LoadMoreButton } from "./styles"
import moment from "moment-timezone"

const ParticipantTiles = ({
  loading,
  filters,
  actions,
  participants,
  gridArea,
  noneText,
  actionHandler,
  filterHandler,
  searchHandler,
  q,
  totalEntries,
  loadMoreHandler,
  clearFilterHandler,
  clearAllFiltersHandler
}) => {
  const [searchValue, setSearchValue] = useState(
    q?.search_string_i_cont || q?.application_container_search_string_i_cont || ""
  )

  const loadMore = (event) => {
    event.preventDefault()
    if (loadMoreHandler !== undefined) loadMoreHandler()
  }

  const handleSearchBox = (event) => {
    const { value } = event.target
    setSearchValue(value)
  }

  const handleFilter = (name, value) => {
    setSearchValue("")
    if (filterHandler !== undefined) filterHandler(name, value)
  }

  return (
    <Grid gap="1rem" gridArea={gridArea}>
      <Filters
        filters={filters}
        filterHandler={handleFilter}
        q={q}
        clearFilterHandler={clearFilterHandler}
        clearAllFiltersHandler={clearAllFiltersHandler}
      />

      <Level mobile={false}>
        <div></div>
        <AdjustedSearchBox
          name="text_search"
          value={searchValue}
          placeholder="Search"
          onChange={handleSearchBox}
          onKeyUp={searchHandler}
        />
      </Level>

      <Actions actions={actions} actionHandler={actionHandler} />

      {loading && (
        <Grid placeContent="center" mobile={true}>
          <LoadingSpinner variant="primary" />
        </Grid>
      )}

      {!loading &&
        (participants.length > 0 ? (
          <Grid gap="2rem">
            <Tiles>
              {participants.map((participant) => (
                <ParticipantTile {...participant} key={participant.id} />
              ))}
            </Tiles>
            {participants.length < totalEntries && (
              <Grid placeContent="center">
                <LoadMoreButton variant="secondary" onClick={loadMore}>
                  Load more
                </LoadMoreButton>
              </Grid>
            )}
            <P bold variant="content" align="center">
              Showing {participants.length} of {totalEntries}
            </P>
          </Grid>
        ) : (
          <P variant="content" marginless>
            {noneText}
          </P>
        ))}
    </Grid>
  )
}

ParticipantTiles.propTypes = {
  loading: PropTypes.bool,
  participants: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.arrayOf(PropTypes.object),
  gridArea: PropTypes.string,
  noneText: PropTypes.string,
  actionHandler: PropTypes.func,
  filterHandler: PropTypes.func,
  searchHandler: PropTypes.func,
  q: PropTypes.object,
  totalEntries: PropTypes.number,
  loadMoreHandler: PropTypes.func,
  clearFilterHandler: PropTypes.func,
  clearAllFiltersHandler: PropTypes.func
}

ParticipantTiles.defaultProps = {
  loading: false,
  participants: [],
  filters: [],
  actions: [],
  gridArea: undefined,
  noneText: "No records.",
  actionHandler: undefined,
  filterHandler: undefined,
  searchHandler: undefined,
  q: {},
  totalEntries: 0,
  loadMoreHandler: undefined,
  clearFilterHandler: undefined,
  clearAllFiltersHandler: undefined
}

export default ParticipantTiles
